export const THERAPY_TOUR_ID = 'patient-therapy'

export const THERAPY_ONBOARDING_STEPS = [
  {
    title: 'Reabilitação no domicílio',
    body: 'Esta aba acompanha a rotina de fisioterapia e terapia. O relato clínico continua na evolução SOAP. Aqui ficam o plano, a sessão do dia, as metas e o histórico.',
  },
  {
    target: '[data-onboarding="therapy-summary"]',
    title: 'Resumo do acompanhamento',
    body: 'Os cartões mostram as atividades ativas, as metas em aberto, a data da última sessão e a última dor registrada.',
  },
  {
    target: '[data-onboarding="therapy-plan"]',
    title: 'Plano de atividades',
    body: 'Cadastre cada exercício com frequência, séries, repetições e orientações. O link de material de apoio serve para o cuidador ou familiar ver como executar.',
  },
  {
    target: '[data-onboarding="therapy-session"]',
    title: 'Registro da sessão',
    body: 'No atendimento, marque o que foi feito, a dor de 0 a 10, o local e a tolerância. Repetir última sessão preenche o checklist com a visita anterior.',
  },
  {
    target: '[data-onboarding="therapy-goals"]',
    title: 'Metas terapêuticas',
    body: 'Registre metas de curto ou longo prazo e conclua quando o paciente alcançar. Uma meta concluída pode ser reaberta.',
  },
  {
    target: '[data-onboarding="therapy-history"]',
    title: 'Histórico',
    body: 'As sessões ficam da mais recente para a mais antiga. Abra uma linha para ver a dor, a tolerância e o checklist daquele dia.',
  },
]
